import React from 'react'

import LinkListSection from '../../../react4xp/components/LinkListSection'

function LinkListPart({ links }) {
    return (
        <LinkListSection
            links={links}
        />
    )
}

export default (props) => <LinkListPart {...props} />
